<latch-loading [isActive]="isGuardsCheckActive">
  <router-outlet></router-outlet>
</latch-loading>
<router-outlet name="popup"></router-outlet>
